module.exports = __webpack_public_path__ + "img/hide-the-pain-harold-learning-crypto-is-great.902ce870.webp";